import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/User';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  user:User;
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.user = this.authService.user$.value;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-dashboard/admin-dashboard.component.ts